import { API } from "@aws-amplify/api";

export const updateBolStatus = `mutation MyMutation($input: updateBolInput) {
    updateBol(input:$input) {
    status
    }
    }`;



export async function updateBolStatusToDB(inputData:any): Promise<any> {
  try {
const response: any = await API.graphql({ query: updateBolStatus, variables: {input: inputData } });
console.log("STATUS", response)
   return response
  } catch (error) {
    console.log("Update Bol Status error:", error);
  }
}